/**
 * foxkit-bundle-variant-sync.js v2
 *
 * Sincroniza el selector de variante del bundle de Foxkit con la variante
 * seleccionada en el producto principal (Minimog theme).
 *
 * Estrategia:
 * 1. Al cargar, reemplaza opciones obsoletas (ej: 300ml) con las variantes reales.
 * 2. MutationObserver vigila re-renders de Foxkit y re-sincroniza.
 * 3. Escucha 'variant:changed' de Minimog para cada cambio de variante.
 * 4. Llama a foxkitCard.onVariantChange() directamente para actualizar precios.
 */
(function () {
  // Lee el variant ID actual desde la URL o el form principal
  function getCurrentVariantId() {
    var urlVariant = new URLSearchParams(location.search).get('variant');
    if (urlVariant) return String(urlVariant);
    var mainInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], variant-picker ~ form input[name="id"]'
    );
    return mainInput ? String(mainInput.value) : '';
  }

  // Reconstruye las opciones del select de Foxkit si están obsoletas
  function rebuildFoxkitOptions(variantId) {
    var sel = document.querySelector('select.foxkit-form-control.combined-variant');
    if (!sel) return;

    var variants = window.FoxKitSettings && window.FoxKitSettings.product && window.FoxKitSettings.product.variants;
    if (!variants || !variants.length) return;

    var productIds = variants.map(function (v) { return String(v.id); });
    var currentOpts = Array.from(sel.options).map(function (o) { return o.value; });
    var hasValid = currentOpts.some(function (v) { return productIds.indexOf(v) > -1; });

    if (!hasValid || currentOpts.indexOf(variantId) < 0) {
      sel.innerHTML = '';
      variants.forEach(function (variant) {
        var opt = document.createElement('option');
        opt.value = variant.id;
        opt.text = variant.title;
        if (String(variant.id) === variantId) opt.selected = true;
        sel.appendChild(opt);
      });
    }
  }

  // Sincroniza el select y notifica a Foxkit del cambio de variante
  function syncFoxkit(variantId) {
    var sel = document.querySelector('select.foxkit-form-control.combined-variant');
    if (!sel) return;

    variantId = String(variantId);

    // Asegurar que la opción existe
    var optExists = Array.from(sel.options).some(function (o) { return o.value === variantId; });
    if (!optExists) {
      rebuildFoxkitOptions(variantId);
    }

    if (sel.value === variantId) return; // ya sincronizado

    sel.value = variantId;

    // Notificar a Foxkit via onVariantChange en la card (acepta llamadas directas)
    var card = document.querySelector('foxkit-product-card.foxkit-product-card--main');
    if (card && typeof card.onVariantChange === 'function') {
      var variants = window.FoxKitSettings && window.FoxKitSettings.product && window.FoxKitSettings.product.variants;
      var variant = variants && variants.find(function (v) { return String(v.id) === variantId; });
      if (variant) {
        try { card.onVariantChange(variant); } catch (e) {}
      }
    }

    // Disparar change como fallback (para otros posibles listeners)
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // MutationObserver: vigila re-renders de Foxkit y re-sincroniza
  function observeFoxkitBundle(variantId) {
    var bundle = document.querySelector('foxkit-product-bundles');
    if (!bundle || bundle._variantSyncObserver) return;

    bundle._variantSyncObserver = new MutationObserver(function () {
      var currentId = getCurrentVariantId();
      rebuildFoxkitOptions(currentId);
      setTimeout(function () { syncFoxkit(currentId); }, 50);
    });
    bundle._variantSyncObserver.observe(bundle, { childList: true, subtree: true });
  }

  // Inicialización principal
  function init() {
    var variantId = getCurrentVariantId();
    rebuildFoxkitOptions(variantId);
    syncFoxkit(variantId);
    observeFoxkitBundle(variantId);
  }

  // Listener para cambios de variante del producto principal (evento de Minimog)
  document.addEventListener('variant:changed', function (event) {
    var variantId = event.detail && event.detail.variant && event.detail.variant.id;
    if (!variantId) return;
    variantId = String(variantId);

    // Pequeño delay para que Minimog termine sus updates de DOM
    setTimeout(function () {
      rebuildFoxkitOptions(variantId);
      syncFoxkit(variantId);
    }, 100);
  });

  // Arrancar tras la carga de la página y Foxkit
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();
